import * as THREE from 'three';
import { MojiDot } from './MojiDot';
import { ConnectingDotsRender } from './ConnectingDotsRender';
import { Moji } from './Moji';

export class ConnectiongDotsCalc{


    mojis:Moji[];
    connectingDotRender:ConnectingDotsRender;

    public Init(mojis:Moji[]){
        
        this.connectingDotRender = ConnectingDotsRender.getInstance();
        this.mojis = mojis;

    }



    public ConnectHorizonal(){

        if(this.mojis==null) return;

        let num = 0;
        for(let j=0;j<this.mojis.length;j++){    
            num = Math.max(
                this.mojis[j].enabledDots.length,
                num
            );
        }

        for(let k=0;k<num;k++){

            for(let j=0;j<this.mojis.length-1;j++){
            
                let dotsA = this.mojis[j+0].enabledDots;
                let dotsB = this.mojis[j+1].enabledDots;

                let dA = dotsA[ (k+j) % dotsA.length ];
                let dB = dotsB[ (k+j) % dotsB.length ];

                if(dA && dB){
                    this.connectingDotRender.connectDots(
                        dA.v.x,dA.v.y,dA.v.z,
                        dB.v.x,dB.v.y,dB.v.z
                    );    
                }

            }

        }

        /*
        for(let j=0;j<this.mojis.length;j++){
            
            let dots = this.mojis[j].enabledDots;
            
            for(let i=0;i<100;i++){

            }

        }*/

    }


    public Connect(){

        if(this.mojis==null) return;

        this.connectingDotRender
        let past = {
            x:0,y:0,z:0
        };

        for(let j=0;j<this.mojis.length;j++){
            
            let firtDot:MojiDot = null;
            let dots = this.mojis[j].enabledDots;

            //console.log(this.mojis[j].enabledDots);
            
            for(let i=0;i<dots.length;i++){

                let dotA = dots[i+0];
                let dotB = i==dots.length-1 ? dots[0] : dots[i+1];

                this.connectingDotRender.connectDots(
                    dotA.v.x,dotA.v.y,dotA.v.z,
                    dotB.v.x,dotB.v.y,dotB.v.z
                );                

            }

            /*
            for(let i=0;i<dots.length;i++){

                let dot = dots[i];

                if(dot.enabled){//ここを調整する

                    if(!firtDot){
                        firtDot=dot;
                    }else{
                        //つなぐ
                        this.connectingDotRender.connectDots(
                            past.x,past.y,past.z,
                            dot.v.x,dot.v.y,dot.v.z,
                        );
                    }

                    past.x = dot.v.x;
                    past.y = dot.v.y;
                    past.z = dot.v.z;                    

                }                
            }*/

            if(firtDot){
                this.connectingDotRender.connectDots(
                    past.x,past.y,past.z,
                    firtDot.v.x,firtDot.v.y,firtDot.v.z,
                );
            }

        }

    }


}